import React from "react";
import SubscriptionPlans from "components/UpgradePlan/SubscriptionPlan";
import StickyBox from "react-sticky-box";
import { Button, Flex } from "antd";
import { Title3 } from "components/Common/Typography/Titles";
import SubscriptionHeader from "components/Subscriptions/SubscriptionHeader";

const SubscriptionPage = () => {
    return (
        <div className="w-reduce-sidebar ml-auto">
            <div className=" h-calc-vh ml-auto bg-utility-Grayblue">
                <StickyBox offsetTop={0} className="z-[1]">
                    <SubscriptionHeader />
                    {/* <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white" align="center">
                        <div className="w-80 pl-6">
                            <Title3 text="Pricing" color="text-text-secondary" className="font-bold" />
                        </div> */}

                    {/* <Button
                            className="relative font-semibold text-sm text-white py-2 px-3 bg-[#845dda] border border-[#7F56D9] flex gap-1 rounded-lg group " */}
                    {/* // onClick={openOnboardingModal}
                        > */}
                    {/* <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.99996 4.1665V15.8332M4.16663 9.99984H15.8333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="svg-path stroke-white group-hover:stroke-primary"
                            />
                        </svg> */}
                    {/* <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 2C6.48 2 2 6.15 2 11C2 13.09 2.89 15.03 4.34 16.57L3 22L8.26 20.26C9.41 20.67 10.68 21 12 21C17.52 21 22 16.85 22 12C22 7.15 17.52 2 12 2ZM12.5 15H11.5V13H12.5V15ZM12 11.5H11V11C11 9.9 11.9 9 13 9C14.1 9 15 9.9 15 11C15 11.74 14.54 12.38 13.91 12.7L12.5 13.5V14H11.5V13L13 12.3C13.54 12.04 14 11.58 14 11C14 10.45 13.55 10 13 10C12.45 10 12 10.45 12 11V11.5Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="svg-path stroke-white group-hover:stroke-primary"
                                />
                            </svg> */}
                    {/* <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 2C6.48 2 2 6.15 2 11C2 13.09 2.89 15.03 4.34 16.57L3 22L8.26 20.26C9.41 20.67 10.68 21 12 21C17.52 21 22 16.85 22 12C22 7.15 17.52 2 12 2Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="svg-path stroke-white group-hover:stroke-primary"
                                />
                                <path
                                    d="M12.5 15H11.5V13H12.5V15ZM12 11.5H11V11C11 9.9 11.9 9 13 9C14.1 9 15 9.9 15 11C15 11.74 14.54 12.38 13.91 12.7L12.5 13.5V14H11.5V13L13 12.3C13.54 12.04 14 11.58 14 11C14 10.45 13.55 10 13 10C12.45 10 12 10.45 12 11V11.5Z"
                                    strokeWidth="0.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="svg-path stroke-white group-hover:stroke-primary"
                                />
                                
                            </svg> */}

                    {/* 
                            Contact Support
                        </Button> */}
                    {/* </Flex> */}
                </StickyBox>
                {/* <div className="other-page-wrapper">
                    <SubscriptionPlans />
                </div> */}
            </div>
        </div>
    );
};

export default SubscriptionPage;
 